// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 1rem; }
  .report-container section {
    position: relative; }

.consumer-report-heading {
  margin-top: 1rem;
  width: 85vw;
  display: flex;
  justify-content: center;
  flex-direction: column; }
  .consumer-report-heading h3 {
    color: white; }
  .consumer-report-heading .breadcrumb-subtitle,
  .consumer-report-heading .breadcrumb-subtitle--parent-section {
    color: white; }

.report-map-container {
  position: relative; }
  .report-map-container .status-box {
    position: absolute;
    top: 2rem;
    z-index: 100;
    color: white;
    font-weight: bold;
    display: flex;
    justify-content: flex-start;
    left: 2rem; }

.zip-menu-header {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem; }

#DrinkingWaterTrueQIReport-report {
  margin-top: 8%; }
  #DrinkingWaterTrueQIReport-report .report-header {
    margin-left: 20px;
    margin-right: 20px;
    width: calc(100% - 20px); }

.report-map-container,
.ccr-graph-container {
  margin-top: 1rem;
  width: 90vw !important;
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }
  .report-map-container table,
  .ccr-graph-container table {
    position: absolute;
    left: 0;
    top: 0; }

.ccr-graph-container::-webkit-scrollbar {
  width: 1em; }

.ccr-graph-container::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); }

.ccr-graph-container::-webkit-scrollbar-thumb {
  background-color: #040e24;
  border-radius: 2px; }

.section-2 {
  color: white;
  margin-top: 1rem;
  background-color: #0b1736;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  display: flex;
  flex-direction: row;
  width: 90vw !important;
  padding: 1.5rem;
  border-radius: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; }
  .section-2 .paginate-btn,
  .section-2 .report-id {
    cursor: pointer;
    padding: 4px;
    margin-left: 1rem;
    margin-right: 1rem; }
  .section-2 .active {
    background-color: white;
    color: #0b1736;
    font-weight: bold;
    border-radius: 4px; }
  .section-2 .report-id:hover {
    background-color: white;
    color: #0b1736;
    font-weight: bold;
    border-radius: 4px; }

.ccr-graph-container {
  height: 50vh;
  background-color: #0b1736;
  position: relative;
  overflow: scroll; }
  .ccr-graph-container h1 {
    color: white; }

.report-table {
  position: absolute;
  top: 8rem;
  left: 0 !important; }
  .report-table .table-head {
    position: sticky;
    top: -25px;
    z-index: 201; }
  .report-table .table-body .table-row {
    border-bottom: black; }

.column-head {
  color: white;
  background-color: #0b1736; }

.header-item:nth-child(14),
.header-item:nth-child(15) {
  text-decoration: underline; }

.table-button {
  position: absolute;
  color: white;
  font-weight: bold;
  background-color: #183378;
  border-radius: 4px;
  z-index: 202;
  right: 2%; }

.header-item,
.table-row,
.table-data {
  color: white;
  font-size: 16px;
  font-weight: bold; }

.chemical {
  position: relative;
  text-decoration: underline; }

.cas-info {
  color: white;
  background-color: #0b1736;
  position: absolute;
  z-index: 200;
  width: 500px;
  top: 0;
  padding: 8px;
  overflow: hidden;
  left: 0;
  border: 1px solid white;
  box-shadow: rgba(255, 255, 255, 0.063) 0px 6px 24px; }
  .cas-info .cas-container strong {
    font-weight: bold;
    margin-right: 4px;
    text-decoration: underline; }

.range-slider {
  position: absolute;
  right: 45%;
  z-index: 60;
  bottom: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  color: white; }
  .range-slider strong {
    margin-left: 6px;
    border: 1px solid white;
    padding: 2px 4px;
    border-radius: 4px; }
  .range-slider .form-range {
    width: 25% !important; }

.range-slider-noaa {
  bottom: 15% !important; }

.flagged {
  border: 3px solid red !important; }

.popup-header {
  position: relative;
  text-decoration: underline;
  cursor: pointer; }
  .popup-header .header-tooltip {
    position: absolute;
    top: 40%;
    z-index: 200;
    background-color: #eeeeee;
    color: black;
    font-weight: 100;
    padding: 2px;
    border-radius: 2px;
    width: 8rem;
    text-align: center; }
    .popup-header .header-tooltip p {
      margin: 0; }

#qiTable {
  top: 45%; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #DrinkingWaterTrueQIReport-report {
    margin-top: 12%; } }
`, "",{"version":3,"sources":["webpack://./src/features/reports/DrinkingWaterTrueQIReport/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB,EAAA;EALlB;IAOI,kBAAkB,EAAA;;AAItB;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB,EAAA;EALxB;IAOI,YAAY,EAAA;EAPhB;;IAWI,YAAY,EAAA;;AAIhB;EACE,kBAAkB,EAAA;EADpB;IAGI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,UAAU,EAAA;;AAId;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,cAAc,EAAA;EADhB;IAII,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB,EAAA;;AAI5B;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;EARrB;;IAUI,kBAAkB;IAClB,OAAO;IACP,MAAM,EAAA;;AAIV;EACE,UAAU,EAAA;;AAGZ;EACE,4CAA4C,EAAA;;AAG9C;EACE,yBAAyB;EACzB,kBAAkB,EAAA;;AAWpB;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B,EAAA;EAbhC;;IAgBI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB,EAAA;EAnBtB;IAuBI,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,kBAAkB,EAAA;EA1BtB;IA+BM,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,kBAAkB,EAAA;;AAKxB;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB,EAAA;EAJlB;IAMI,YAAY,EAAA;;AAIhB;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB,EAAA;EAHpB;IAKI,gBAAgB;IAChB,UAAU;IACV,YAAY,EAAA;EAPhB;IAWM,oBAAoB,EAAA;;AAK1B;EACE,YAAY;EACZ,yBAAyB,EAAA;;AAG3B;;EAEE,0BAA0B,EAAA;;AAG5B;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,SAAS,EAAA;;AAGX;;;EAGE,YAAY;EACZ,eAAe;EACf,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,0BAA0B,EAAA;;AAG5B;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,uBAAuB;EACvB,mDAAmD,EAAA;EAXrD;IAcM,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B,EAAA;;AAKhC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY,EAAA;EATd;IAWI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB,EAAA;EAdtB;IAiBI,qBAAqB,EAAA;;AAIzB;EACE,sBAAsB,EAAA;;AAGxB;EACE,gCAAgC,EAAA;;AAGlC;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe,EAAA;EAHjB;IAKI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,kBAAkB,EAAA;IAdtB;MAgBM,SAAS,EAAA;;AAKf;EACE,QAAQ,EAAA;;AAGV;EACE;IACE,eAAe,EAAA,EAChB","sourcesContent":[".report-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n  section {\n    position: relative;\n  }\n}\n\n.consumer-report-heading {\n  margin-top: 1rem;\n  width: 85vw;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  h3 {\n    color: white;\n  }\n  .breadcrumb-subtitle,\n  .breadcrumb-subtitle--parent-section {\n    color: white;\n  }\n}\n\n.report-map-container {\n  position: relative;\n  .status-box {\n    position: absolute;\n    top: 2rem;\n    z-index: 100;\n    color: white;\n    font-weight: bold;\n    display: flex;\n    justify-content: flex-start;\n    left: 2rem;\n  }\n}\n\n.zip-menu-header {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n#DrinkingWaterTrueQIReport-report {\n  margin-top: 8%;\n\n  .report-header {\n    margin-left: 20px;\n    margin-right: 20px;\n    width: calc(100% - 20px);\n  }\n}\n\n.report-map-container,\n.ccr-graph-container {\n  margin-top: 1rem;\n  width: 90vw !important;\n  height: 50vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  table {\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n}\n\n.ccr-graph-container::-webkit-scrollbar {\n  width: 1em;\n}\n\n.ccr-graph-container::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\n.ccr-graph-container::-webkit-scrollbar-thumb {\n  background-color: #040e24;\n  border-radius: 2px;\n}\n\n// .ccr-graph-container {\n//   position: relative;\n//   .report-table {\n//     position: absolute;\n//     left: -7%\n//   }\n// }\n\n.section-2 {\n  color: white;\n  margin-top: 1rem;\n  background-color: #0b1736;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  display: flex;\n  flex-direction: row;\n  width: 90vw !important;\n  padding: 1.5rem;\n  border-radius: 12px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  .paginate-btn,\n  .report-id {\n    cursor: pointer;\n    padding: 4px;\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n\n  .active {\n    background-color: white;\n    color: #0b1736;\n    font-weight: bold;\n    border-radius: 4px;\n  }\n\n  .report-id {\n    &:hover {\n      background-color: white;\n      color: #0b1736;\n      font-weight: bold;\n      border-radius: 4px;\n    }\n  }\n}\n\n.ccr-graph-container {\n  height: 50vh;\n  background-color: #0b1736;\n  position: relative;\n  overflow: scroll;\n  h1 {\n    color: white;\n  }\n}\n\n.report-table {\n  position: absolute;\n  top: 8rem;\n  left: 0 !important;\n  .table-head {\n    position: sticky;\n    top: -25px;\n    z-index: 201;\n  }\n  .table-body {\n    .table-row {\n      border-bottom: black;\n    }\n  }\n}\n\n.column-head {\n  color: white;\n  background-color: #0b1736;\n}\n\n.header-item:nth-child(14),\n.header-item:nth-child(15) {\n  text-decoration: underline;\n}\n\n.table-button {\n  position: absolute;\n  color: white;\n  font-weight: bold;\n  background-color: #183378;\n  border-radius: 4px;\n  z-index: 202;\n  right: 2%;\n}\n\n.header-item,\n.table-row,\n.table-data {\n  color: white;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.chemical {\n  position: relative;\n  text-decoration: underline;\n}\n\n.cas-info {\n  color: white;\n  background-color: #0b1736;\n  position: absolute;\n  z-index: 200;\n  width: 500px;\n  top: 0;\n  padding: 8px;\n  overflow: hidden;\n  left: 0;\n  border: 1px solid white;\n  box-shadow: rgba(255, 255, 255, 0.063) 0px 6px 24px;\n  .cas-container {\n    strong {\n      font-weight: bold;\n      margin-right: 4px;\n      text-decoration: underline;\n    }\n  }\n}\n\n.range-slider {\n  position: absolute;\n  right: 45%;\n  z-index: 60;\n  bottom: 10%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  color: white;\n  strong {\n    margin-left: 6px;\n    border: 1px solid white;\n    padding: 2px 4px;\n    border-radius: 4px;\n  }\n  .form-range {\n    width: 25% !important;\n  }\n}\n\n.range-slider-noaa {\n  bottom: 15% !important;\n}\n\n.flagged {\n  border: 3px solid red !important;\n}\n\n.popup-header {\n  position: relative;\n  text-decoration: underline;\n  cursor: pointer;\n  .header-tooltip {\n    position: absolute;\n    top: 40%;\n    z-index: 200;\n    background-color: #eeeeee;\n    color: black;\n    font-weight: 100;\n    padding: 2px;\n    border-radius: 2px;\n    width: 8rem;\n    text-align: center;\n    p {\n      margin: 0;\n    }\n  }\n}\n\n#qiTable {\n  top: 45%;\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n  #DrinkingWaterTrueQIReport-report {\n    margin-top: 12%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
